import React, {Fragment} from 'react'

export default function TextWithLinebreaks({as, text, ...props}: any) {
	const Comp = as || 'p'
	return (
		<Comp {...props}>
			{text.trim().split('\n').map((item: any, key: number) => {
        return <Fragment key={key}>{item}<br/></Fragment>
      })}
    </Comp>
	)
}
